<med-label
  mode="column"
  [label]="label"
  [name]="name"
  [disabled]="disabled"
  [required]="required"
  [labelClass]="labelClass"
  [backwards]="backwards"
>
  <label
    [attr.for]="name"
    class="med-switch"
    [ngClass]="classList"
  >
    <input
      type="checkbox"
      class="med-switch__input"
      [id]="name"
      [name]="name"
      [disabled]="disabled"
      [required]="required"
      [(ngModel)]="value"
      (change)="onInput.emit(value)"
    />

    <div
      [ngClass]="classList"
      class="field med-switch__box"
    >
      <div class="med-switch__circle"></div>
    </div>
  </label>
</med-label>

<div
  *ngIf="invalid"
  class="field__error-message"
>
  {{ errorMessage }}
</div>
